import { AppRecord, AppRecordStatus } from "models/appRecord";
import printJS from "print-js";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import appStore from "store/appStore";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

const useTimeSheetAction = () => {
  const { showDialogMessage } = appStore();

  const location = useLocation();
  const { token } = useAppSelector((state) => state.auth);
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [storage_host_cluster_Id, setStorage_host_cluster_Id] = useState<any>();
  const [departmentTimeSheet, setDepartmentTimeSheet] = useState<any>();
  const [loadingDepartmentTimeSheet, setloadingDepartmentTimeSheet] = useState<boolean>(false);
  const [attendanceSetting, setAttendanceSetting] = useState<any>({
    early_exception: "",
    late_exception: "",
    alert_telegram_lang: "",
  });
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);

  const fetchDepartmentTimeSheet = async () => {
    setloadingDepartmentTimeSheet(true);
    try {
      const url = `${RouteApi.getShopEmployeeTimesheetDepartment}token=${token}`;
      const data = {
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setloadingDepartmentTimeSheet(false);
        setDepartmentTimeSheet(response.user_shop_departments);
        setStorage_host_cluster_Id(response.storage_host_cluster);
        setAttendanceSetting({
          early_exception: response.attendance_setting.early_exception,
          late_exception: response.attendance_setting.late_exception,
          max_compassionate_leave: response.attendance_setting.max_compassionate_leave,
          max_change_day_off_leave: response.attendance_setting.max_change_day_off_leave,
          max_marriage_leave: response.attendance_setting.max_marriage_leave,
          max_maternity_leave: response.attendance_setting.max_maternity_leave,
          max_paternity_leave: response.attendance_setting.max_paternity_leave,
          max_special_leave: response.attendance_setting.max_special_leave,
          max_suspend_leave: response.attendance_setting.max_suspend_leave,
          max_unpaid_leave: response.attendance_setting.max_unpaid_leave,
          annual_leave: response.attendance_setting.annual_leave,
          sick_leave: response.attendance_setting.sick_leave,
          max_block_leave: response.attendance_setting.max_block_leave,
          max_sick_leave: response.attendance_setting.max_sick_leave,
          max_annual_leave: response.attendance_setting.max_annual_leave,
          alart_telegram: response.attendance_setting.alart_telegram,
          alert_telegram_id: response.attendance_setting.alert_telegram_id,
          alert_telegram_lang: response.attendance_setting.alert_telegram_lang,
        });
      } else {
        setloadingDepartmentTimeSheet(false);
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error) {
      setloadingDepartmentTimeSheet(false);
      AppLog.show({
        message: `[fetchDepartmentTimeSheet]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const loadingProductState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };
  // -----------------------------shop Employee-------------------------------------
  const [shopEmployeeTimesheets, setShopEmployeeTimesheets] = useState<any>();
  const [shopEmployeeLoading, setShopEmployeeLoading] = useState<any>(null);
  const [shopEmployeeLoadingState, setShopEmployeeLoadingState] = useState<any>(null);
  const [dob, setDob] = useState(new Date().toISOString().split("T")[0]); // "2025-05-05"
  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const getShopEmployeeTimesheetSearch = async () => {
    setShopEmployeeLoadingState(true);
    try {
      const url = `${RouteApi.getShopEmployeeTimesheetSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: dob,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeeLoadingState(false);
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["employee_timesheets"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["employee_timesheets"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        setShopEmployeeTimesheets(response.employee_timesheets);
        setShopEmployeeLoading(stateRecord);
      } else {
        console.log(response, "error fetch shop employee ");
        setShopEmployeeLoadingState(false);
      }
    } catch (error) {
      setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const fetchMoreShopEmployeeTimesheetSearch = async ({ next }: { next: string }) => {
    if (!next) return;

    setShopEmployeeLoading({
      ...loadingProductState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    try {
      const responses = await RequestApi(next);

      if (responses.status === "success") {
        const newEmployees = responses["employee_timesheets"]["data"];
        const nextPage = responses["employee_timesheets"]["next_page_url"];

        const updatedData = [...(shopEmployeeTimesheets?.data || []), ...newEmployees];

        setShopEmployeeTimesheets({
          ...responses["employee_timesheets"],
          data: updatedData,
        });

        setShopEmployeeLoading({
          ...loadingProductState,
          nextPageUrl: nextPage ?? "",
          loadingStatus: nextPage ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        });
      }
    } catch (error) {
      console.error("Failed to fetch more employees:", error);
    }
  };

  //   ------------------------------------------
  const [employeeTimesheetDetail, setEmployeeTimesheetDetail] = useState<any>();
  const [shopEmployeeDetailLoadingState, setShopEmployeeDetailLoadingState] = useState<any>(null);
  const getShopEmployeeTimesheetDetail = async (id: any) => {
    setShopEmployeeDetailLoadingState(true);
    try {
      const url = `${RouteApi.getShopEmployeeTimesheetDetail}token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: dob,
        employee_id: id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeeDetailLoadingState(false);
        setEmployeeTimesheetDetail(response.employee_timesheets);
      } else {
        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setShopEmployeeDetailLoadingState(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetDetail]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  // ===========submitUpdateClockTime===============
  const [timeInValues, setTimeInValues] = useState<string[]>([]);
  const [breakInValues, setBreakInValues] = useState<string[]>([]);
  const [timeOutValues, setTimeOutValues] = useState<string[]>([]);
  const [breakOutValues, setbreakOutValues] = useState<string[]>([]);
  const [openDrawer, setOpenDrawer] = useState<number | null>(null);
  const [openPopoverInTime, setOpenPopoverInTime] = useState<number | null>(null);
  const [openPopoverbreakOutTime, setOpenPopoverbreakOutTime] = useState<number | null>(null);
  const [openPopoverbreakInTime, setOpenPopoverbreakInTime] = useState<number | null>(null);
  const [openPopoverOutTime, setOpenPopoverOutTime] = useState<number | null>(null);
  const [loadingsubmitUpdateClockTime, setLoadingsubmitUpdateClockTime] = useState<boolean>(false);
  const submitUpdateClockTime = async (working_mode: string, id: number, index: number) => {
    setLoadingsubmitUpdateClockTime(true);
    try {
      const url = `${RouteApi.submitUpdateClockTime}token=${token}`;
      const data = {
        shop_id: shopId,
        id: id,
        working_mode: working_mode,
        working_time:
          (working_mode === "Time In"
            ? timeInValues[index]
            : working_mode === "Break Out"
            ? breakOutValues[index]
            : working_mode === "Break In"
            ? breakInValues[index]
            : timeOutValues[index]) ?? "",
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingsubmitUpdateClockTime(false);
        setOpenPopoverInTime(null); // ✅ CLOSE the popover
        setOpenPopoverbreakOutTime(null); // ✅ CLOSE the popover
        setOpenPopoverbreakInTime(null); // ✅ CLOSE the popover
        setOpenPopoverOutTime(null); // ✅ CLOSE the popover
        setShopEmployeeTimesheets((prev: any) => ({
          ...prev,
          data: prev.data.map((item: any) => (item.id === response.employee_timesheet.id ? response.employee_timesheet : item)),
        }));
      } else {
        setLoadingsubmitUpdateClockTime(false);
        showDialogMessage({
          title: response.status,
          message: response.msg,
          barrierDismissible: false,
        });
      }
    } catch (error) {
      setLoadingsubmitUpdateClockTime(false);
      AppLog.show({
        message: `[submitUpdateClockTime]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  // ------------------------------
  const handleChangeTimeIn = (index: number, val: string) => {
    setTimeInValues((prev) => {
      const updated = [...prev];
      updated[index] = val;
      return updated;
    });
  };
  const handleChangeBreakOut = (index: number, val: string) => {
    setbreakOutValues((prev) => {
      const updated = [...prev];
      updated[index] = val;
      return updated;
    });
  };
  const handleChangeBreakIn = (index: number, val: string) => {
    setBreakInValues((prev) => {
      const updated = [...prev];
      updated[index] = val;
      return updated;
    });
  };
  const handleChangeTimeOut = (index: number, val: string) => {
    setTimeOutValues((prev) => {
      const updated = [...prev];
      updated[index] = val;
      return updated;
    });
  };
  //   ------------------------------
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false);
  const handlePrint = async () => {
    setLoadingPrint(true);
    try {
      const url = `${storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-timesheet-report?token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: dob,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
        storage_host_cluster_id: storage_host_cluster_Id.id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);

        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);
      setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[handlePrint]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [itemsDetail, setItemDetail] = useState<any>();

  const handlePrintMonthly = async () => {
    setLoadingPrint(true);
    try {
      const url = `${storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-timesheet-monthly-report?token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: dob,
        search_text: searchTextInput,
        employee_id: itemsDetail?.employee_id,
        storage_host_cluster_id: storage_host_cluster_Id.id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);
        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);
      setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[handlePrintMonthly]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const handleClickUrl = (id: string, urlString: string, working_data: any) => {
    const params = new URLSearchParams(location.search);
    const existingId = params.get("id"); // assuming ?id=... is required
    if (existingId) {
      const url = new URL(window.location.href);
      url.searchParams.set(urlString, id); // add or update param
      url.searchParams.set("working_data", working_data); // add or update param

      window.history.pushState({}, "", url.toString());
    }
  };
  return {
    handleClickUrl,
    itemsDetail,
    setItemDetail,
    handlePrintMonthly,
    loadingPrint,
    setLoadingPrint,
    handlePrint,
    // --------------
    handleChangeTimeIn,
    handleChangeBreakOut,
    handleChangeBreakIn,
    handleChangeTimeOut,
    // ------------------------------
    fetchDepartmentTimeSheet,
    attendanceSetting,
    setAttendanceSetting,
    errorStatus,
    setErrorStatus,
    warning,
    setWarning,
    storage_host_cluster_Id,
    setStorage_host_cluster_Id,
    departmentTimeSheet,
    setDepartmentTimeSheet,
    loadingDepartmentTimeSheet,
    setloadingDepartmentTimeSheet,
    // ----------------
    getShopEmployeeTimesheetSearch,
    fetchMoreShopEmployeeTimesheetSearch,
    shopEmployeeTimesheets,
    setShopEmployeeTimesheets,
    shopEmployeeLoading,
    setShopEmployeeLoading,
    shopEmployeeLoadingState,
    setShopEmployeeLoadingState,
    dob,
    setDob,
    searchTextInput,
    setSearchTextInput,
    selectedProductGroupCode,
    setSelectedProductGroupCode,
    // ---------------------------
    employeeTimesheetDetail,
    setEmployeeTimesheetDetail,
    shopEmployeeDetailLoadingState,
    setShopEmployeeDetailLoadingState,
    getShopEmployeeTimesheetDetail,
    // ------------------------
    submitUpdateClockTime,
    timeInValues,
    setTimeInValues,
    breakInValues,
    setBreakInValues,
    timeOutValues,
    setTimeOutValues,
    breakOutValues,
    setbreakOutValues,
    openDrawer,
    setOpenDrawer,
    openPopoverInTime,
    setOpenPopoverInTime,
    openPopoverbreakOutTime,
    setOpenPopoverbreakOutTime,
    openPopoverbreakInTime,
    setOpenPopoverbreakInTime,
    openPopoverOutTime,
    setOpenPopoverOutTime,
    loadingsubmitUpdateClockTime,
    setLoadingsubmitUpdateClockTime,
  };
};

export default useTimeSheetAction;
